module.exports = __webpack_public_path__ + "img/sector_plus.f656de89.svg";